module.exports = "<header>\n  \n</header>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.html
// module id = 134
// module chunks = 1